import { render, staticRenderFns } from "./ArchiveButton.vue?vue&type=template&id=f965e8e4&scoped=true"
import script from "./ArchiveButton.vue?vue&type=script&lang=ts"
export * from "./ArchiveButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f965e8e4",
  null
  
)

export default component.exports